/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { StartBotOptions, StartBotResponses } from '../types/StartBot'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Start a bot
 * {@link /v1/bots/:bot_id/start}
 */
export function startBot<ThrowOnError extends boolean = true>(
  options: Options<StartBotOptions, ThrowOnError>,
): Unwrappable<RequestResult<StartBotResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/bots/{bot_id}/start',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<StartBotResponses, ThrowOnError>>,
  )
}
